module.exports = __webpack_public_path__ + "static/media/full_export_list_ic.5ca2b7c2.svg";